// Автогенерируемый агрегатор локали — 20 батчей по 6 квизов.
import b1 from './batch1.json';
import b2 from './batch2.json';
import b3 from './batch3.json';
import b4 from './batch4.json';
import b5 from './batch5.json';
import b6 from './batch6.json';
import b7 from './batch7.json';
import b8 from './batch8.json';
import b9 from './batch9.json';
import b10 from './batch10.json';
import b11 from './batch11.json';
import b12 from './batch12.json';
import b13 from './batch13.json';
import b14 from './batch14.json';
import b15 from './batch15.json';
import b16 from './batch16.json';
import b17 from './batch17.json';
import b18 from './batch18.json';
import b19 from './batch19.json';
import b20 from './batch20.json';

const batches = [
  b1,
  b2,
  b3,
  b4,
  b5,
  b6,
  b7,
  b8,
  b9,
  b10,
  b11,
  b12,
  b13,
  b14,
  b15,
  b16,
  b17,
  b18,
  b19,
  b20,
];

export default batches.flat();
